<template>
  <div class="select_dialog_embed">
    <div class="setup_shop_embed_msg">
      <div v-if="shopStatus !== 'synchronousInventoryDisable'" class="select_dialog_embed_box"
           :class="{'select_dialog_embed_box_w930': showType === 'configureChannels', 'select_dialog_embed_box_w760': showType === 'orderSetting'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}
            <span v-if="showType === 'configureChannels'" class="fcDel">（配仓优先级不填写默认为0，为0时优先程度最低）</span>
          </p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--新增/编辑店铺-->
          <div v-if="showType === 'addShop' || showType === 'modifyShop'" class="select_dialog_embed_box_handle">
            <div v-if="showType === 'addShop'">
              <label><i>*</i>来源：</label>
              <div class="inb">
                <el-select v-model="selectSource" placeholder="请选择来源">
                  <el-option
                    v-for="item in shopSourceList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <label><i>*</i>店铺名称：</label>
              <input type="text" title="店铺名称" maxlength="98" v-model.trim="shopName">
            </div>
            <div v-if="selectSource !== '3' && selectSource !== 3">
              <label><i>*</i>店铺昵称：</label>
              <input type="text" title="店铺昵称" maxlength="98" v-model.trim="shopNickName">
            </div>

            <div v-if="selectSource === '3' || selectSource === 3">
              <label><i>*</i>商家ID：</label>
              <input type="text" title="商家ID" maxlength="98" v-model.trim="shopNickName">
            </div>
            <div v-if="selectSource === '3' || selectSource === 3">
              <label><i>*</i>店铺ID：</label>
              <input type="text" title="店铺ID" maxlength="98" v-model.trim="outShopId">
            </div>
           <!-- <div>
              <label>appkey：</label>
              <input type="text" title="appkey" v-model="appKey">
            </div>
            <div>
              <label>appSecrect：</label>
              <input type="text" title="appSecrect" v-model="appSecret">
            </div>
            <div>
              <label>sessionKey：</label>
              <input type="text" title="sessionKey" v-model="sessionKey">
            </div> -->
          </div>

          <!--删除角色-->
          <div v-if="showType === 'delRole'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要删除当前角色，删除后数据将不可进行恢复！
            </div>
          </div>

          <!--同步库存-->
          <div v-if="showType === 'synchronousInventory'" class="select_dialog_embed_box_handle">
            <div class="text_center" style="margin-bottom: 40px">
              请确定是否要同步整店库存，同步时间约需要30~90分钟！
            </div>
          </div>

          <!--查看密钥-->
          <div v-if="showType === 'checkTheKey'" class="select_dialog_embed_box_handle" style="width: 97%;">
            <div class="text_center newline">
              <p class="text_left mb10"><span class="inb w84 text_right">appkey：</span>{{appKeyTxt}}</p>
              <p class="text_left mb10"><span class="inb w84 text_right">appsecret：</span>{{appSecret}}</p>
              <p class="text_left mb10"><span class="inb w84 text_right">sessionkey：</span>{{sessionKey}}</p>
            </div>
          </div>

          <!--启用店铺-->
          <div v-if="showType === 'enableShop'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要启用当前店铺，启用后店铺可正常使用！
            </div>
          </div>

          <!--停用店铺-->
          <div v-if="showType === 'disableShop'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要停用当前店铺，停用后店铺将不再使用！
            </div>
          </div>

          <!--删除店铺-->
          <div v-if="showType === 'delShop'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要删除当前店铺，删除后数据将不可进行恢复！
            </div>
          </div>

          <!--配置对接渠道-->
          <div v-if="showType === 'configureChannels'" class="select_dialog_embed_box_handle">
           <!-- <div class="mt20">
              <input type="checkbox" id="startCostLimit" v-model="startCostLimit">
              <label for="startCostLimit">开启通过成本限制过滤库存</label>
            </div>
            <div>
              <label>成本限制过滤：</label>
              <input type="text" title="库存同步配货率限制" @blur="limitCostFormat(-1, costLimit)" v-model.trim="costLimit">
            </div>
            <div>
              <input type="checkbox" id="startRationLimit" v-model="startRationLimit">
              <label for="startRationLimit">开启通过配货率限制过滤库存</label>
            </div>
            <div class="mb20">
              <label>库存同步配货率限制：</label>
              <input type="text" title="库存同步配货率限制" v-model.trim="rationLimitVal" @blur="rationLimitValFormat()">%
            </div> -->
            <div>
              <table id="checkAll" class="table" ref="checkAllDom">
                <thead>
                <tr>
                  <th class="pl10 pr10"><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()">
                  </th>
                  <th>渠道名称</th>
                  <th>配货率</th>
                  <th>订单配仓优先级</th>
                  <th>库存同步成本限制</th>
                  <th>同步库存比率</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in channelList" :key="index">
                  <td class="pl10 pr10"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
                  <td>{{item.StoreroomName}}</td>
                  <td>{{item.RealSendRate}}%</td>
                  <td><input type="text" title="订单配仓优先级" @blur="judgeNum(index)"
                             v-model.trim="item.SetOrderNum"></td>
                  <td><input type="text" title="库存同步成本限制" @blur="limitCostFormat(index, 'LimitCost')"
                             v-model.trim="item.LimitCost"></td>
                  <td><input type="text" title="库存同步成本限制" @blur="limitCostFormat(index, 'SyncStockRate')"
                             v-model.trim="item.SyncStockRate"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--同步订单设置-->
          <div v-if="showType === 'orderSetting'" class="select_dialog_embed_box_handle" style="margin-top: 5px">
            <div>
              <span>售后成功旗帜：</span>
              <input class="pointer" type="radio" v-model="flags" name="flags" title="红" value="1"><img src="../../../assets/img/flag_red.png" height="12" width="12"/>
              <input class="pointer ml5" type="radio" v-model="flags" name="flags" title="黄" value="2"><img src="../../../assets/img/flag_yellow.png" height="12" width="12"/>
              <input class="pointer ml5" type="radio" v-model="flags" name="flags" title="绿" value="3"><img src="../../../assets/img/flag_green.png" height="12" width="12"/>
              <input class="pointer ml5" type="radio" v-model="flags" name="flags" title="蓝" value="4"><img src="../../../assets/img/flag_blue.png" height="12" width="12"/>
              <input class="pointer ml5" type="radio" v-model="flags" name="flags" title="紫" value="5"><img src="../../../assets/img/flag_purple.png" height="12" width="12"/>
            </div>
            <div>
              <input type="checkbox" id="openAutomaticAfterSales" v-model="openAutomaticAfterSales">
              <label for="openAutomaticAfterSales">开启售后自动受理</label>
            </div>
            <div>
              <!--<input type="checkbox" id="openAutomaticPayment" v-model="openAutomaticPayment">-->
              <!--<label for="openAutomaticPayment">开启自动付款</label>-->
              <input type="checkbox" id="openAutomaticCheck" v-model="openAutomaticCheck">
              <label for="openAutomaticCheck">开启自动审单</label>
            </div>
            <div>
              <input type="checkbox" id="openAutomaticRemovalInvoice" v-model="openAutomaticRemovalInvoice">
              <label for="openAutomaticRemovalInvoice">开启自动拆单</label>
            </div>
            <div>
              <input type="checkbox" id="openBuyerAutomaticFiltering" v-model="openBuyerAutomaticFiltering">
              <label for="openBuyerAutomaticFiltering">开启买家备注自动过滤</label>
            </div>
            <div class="remark">
              <p>注：买家备注包含以下关键字订单下载时会自动取消，且会进行系统备注“过滤”。多个关键字采用“；”进行隔开。</p>
              <textarea title="备注内容" v-model.trim="openBuyerAutomaticFilteringTxt" maxlength="500"></textarea>
            </div>
            <div>
              <input type="checkbox" id="openSellAutomaticRemovalInvoice" v-model="openSellAutomaticRemovalInvoice">
              <label for="openSellAutomaticRemovalInvoice">开启卖家备注自动过滤</label>
              <span class="fcDel">（使用此功能时建议关闭自动审单）</span>
            </div>
            <div class="remark">
              <p>注：卖家备注包含以下关键字订单下载时会自动取消，且会进行系统备注“过滤”。多个关键字采用“;”进行隔开。</p>
              <textarea v-model.trim="openSellAutomaticRemovalInvoiceTxt" title="卖家备注" maxlength="500"></textarea>
            </div>
            <div>
              <input type="checkbox" id="openBuyerNoteReplacement" v-model="openBuyerNoteReplacement">
              <label for="openBuyerNoteReplacement">开启买家备注置换</label>
            </div>
            <div class="remark">
              <p>注：买家备注包含以下关键字订单下载时会自动进行改货成置换物品，且会进行系统备注“置换”。
                设置格式为”关键字|SKU商家编码“，多个关键字采用”；“进行隔开。</p>
              <textarea v-model.trim="openBuyerNoteReplacementTxt" title="买家备注" maxlength="500"></textarea>
            </div>
            <div>
              <input type="checkbox" id="openSellNoteReplacement" v-model="openSellNoteReplacement">
              <label for="openSellNoteReplacement">开启卖家备注自动过滤</label>
              <span class="fcDel">（使用此功能时建议关闭自动付款）</span>
            </div>
            <div class="remark">
              <p>注：卖家备注包含以下关键字订单下载时会自动进行改货成置换物品，且会进行系统备注“置换”。
                设置格式为”关键字|SKU商家编码“，多个关键字采用”；“进行隔开。</p>
              <textarea v-model.trim="openSellNoteReplacementTxt" title="卖家备注" maxlength="500"></textarea>
            </div>
            <div>
              <span class="mr15">配仓同渠道优先模式：</span>
              <input v-model="storehouseChannelPriority" type="radio" name="storehouseChannelPriority" value="1" title="地域优先" id="area"><label for="area">地域优先</label>
              <!--<input v-model="storehouseChannelPriority" type="radio" name="storehouseChannelPriority" value="2" title="成本优先" id="cost_price"><label for="cost_price">成本优先</label>-->
              <input v-model="storehouseChannelPriority" type="radio" name="storehouseChannelPriority" value="2" title="优先级优先" id="cost_price"><label for="cost_price">优先级优先</label>
            </div>
          </div>

          <!--查看店铺申请拒绝原因-->
          <div v-if="showType === 'refusedReason'" class="select_dialog_embed_box_handle">
            <textarea class="w_percent100 h80" title="店铺申请拒绝原因" v-model.trim="refusedReason" disabled></textarea>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button v-if="showType !== 'checkTheKey' && showType !== 'refusedReason'" class="btn_normal" @click="submitBtn()">提交</button>
          <button class="btn_cancel" @click="cancelBtn(false, false)">取消</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'setup-shop-embed-msg',
    /**
     *  title：  头部名
     *  showType: addShop=新增店铺  modifyShop=编辑店铺  enableShop=启用店铺  disableShop=停用店铺
     *            delShop=删除店铺  configureChannels=配置渠道
     *            appSecret=appSecret详情  sessionKey=sessionKey详情  synchronousInventory=同步库存
     *  shopMsg: 店铺信息
     * */
    props: ['title', 'showType', 'shopMsg'],
    components: {MsgDialog},
    watch: { // 深度 watcher
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
      } // 单选
    },
    data() {
      return {
        appKeyTxt: '', // 密钥内容
        startCostLimit: false, // 开启通过成本限制过滤库存
        costLimit: '', // 成本限制过滤
        startRationLimit: false, // 开启通过配货率限制过滤库存
        rationLimitVal: '', // 库存同步配货率限制
        channelList: [], // 渠道列表
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        shopName: '', // 店铺名称
        shopNickName: '', // 店铺昵称/商家ID
        outShopId: '', // 店铺ID
        appKey: '', // 店铺appKey
        appSecret: '', // 店铺appSecret
        sessionKey: '', // 店铺sessionKey
        shopSourceList: [], // 下拉店铺来源列表
        selectSource: '所有来源', // 选择的店铺来源
        shopStatus: '', // 同步库存的时候，判断店铺的状态是否启用
        flags: null, // 旗帜
        openAutomaticAfterSales: false, // 开启自动售后受理
        openAutomaticCheck: false, // 自动审单
        openAutomaticRemovalInvoice: false, // 开启自动拆单
        openBuyerAutomaticFiltering: false, // 开启买家备注自动过滤
        openBuyerAutomaticFilteringTxt: '', // 开启买家备注自动过滤备注
        openSellAutomaticRemovalInvoice: false, // 开启卖家备注自动过滤
        openSellAutomaticRemovalInvoiceTxt: '', // 开启卖家备注自动过滤备注
        openBuyerNoteReplacement: false, // 开启买家备注置换
        openBuyerNoteReplacementTxt: '', // 开启买家备注置换备注
        openSellNoteReplacement: false, // 开启卖家备注自动过滤
        openSellNoteReplacementTxt: '', // 开启卖家备注自动过滤备注
        refusedReason: '', // 拒绝的原因
        storehouseChannelPriority: 0, // 配仓同渠道优先模式
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 获取平台来源下拉框信息
      getAllPXOpenPlatformList() {
        this.$axios.get(this.Global.getAllPXOpenPlatformList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.shopSourceList = res.data.resData;
            this.shopSourceList.splice(0, 0, {id: '', text: '所有来源'});
          } else {
            // alert(res.data.errorMsg);
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 根据ID获取店铺信息
      getShopModelById() {
        this.$axios.post(this.Global.getShopModelById(this.shopMsg.Id), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.shopName = res.data.resData.ShopName;
            this.shopNickName = res.data.resData.ShopNick;
          } else {
            // alert(res.data.errorMsg);
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 同步整店库存
      updateOneShopGoodsStock() {
        this.$axios.post(this.Global.updateOneShopGoodsStock(this.shopMsg.Id), null).then((res) => {
          this.handleRequset(res.data);
        });
      },

      // 查询店铺同步订单设置
      getSynchTradeSetting() {
        this.$axios.post(this.Global.getSynchTradeSetting(this.shopMsg.Id), null).then((res) => {
          this.openAutomaticCheck = res.data.resData.IsAutoVerify;
          this.openAutomaticRemovalInvoice = res.data.resData.IsAutoSpit;
          this.openBuyerAutomaticFiltering = res.data.resData.IsBuyerRemarkAutoFilter;
          this.openBuyerAutomaticFilteringTxt = res.data.resData.BuyerRemarkAutoFilterInfo;
          this.openSellAutomaticRemovalInvoice = res.data.resData.IsSellerRemarkAutoFilter;
          this.openSellAutomaticRemovalInvoiceTxt = res.data.resData.SellerRemarkAutoFilterInfo;
          this.openBuyerNoteReplacement = res.data.resData.IsBuyerRemarkExchange;
          this.openBuyerNoteReplacementTxt = res.data.resData.BuyerRemarkExchangeInfo;
          this.openSellNoteReplacement = res.data.resData.IsSellerRemarkExchange;
          this.openSellNoteReplacementTxt = res.data.resData.SellerRemarkExchange;
          this.storehouseChannelPriority = res.data.resData.StoreroomPriorityMode;
          // this.flags = toString(res.data.resData.ReturnSuccessBanner);
          this.flags = res.data.resData.ReturnSuccessBanner;
          this.openAutomaticAfterSales = res.data.resData.IsReturnAutoAccept;
        });
      },

      // 店铺订单同步设置
      synchTradeSetting() {
        const params = {
          ShopId: this.shopMsg.Id,
          IsAutoVerify: this.openAutomaticCheck,
          IsAutoSpit: this.openAutomaticRemovalInvoice,
          IsBuyerRemarkAutoFilter: this.openBuyerAutomaticFiltering,
          BuyerRemarkAutoFilterInfo: this.openBuyerAutomaticFilteringTxt,
          IsSellerRemarkAutoFilter: this.openSellAutomaticRemovalInvoice,
          SellerRemarkAutoFilterInfo: this.openSellAutomaticRemovalInvoiceTxt,
          IsBuyerRemarkExchange: this.openBuyerNoteReplacement,
          BuyerRemarkExchangeInfo: this.openBuyerNoteReplacementTxt,
          IsSellerRemarkExchange: this.openSellNoteReplacement,
          SellerRemarkExchange: this.openSellNoteReplacementTxt,
          StoreroomPriorityMode: parseInt(this.storehouseChannelPriority),
          IsReturnAutoAccept: this.openAutomaticAfterSales,
          ReturnSuccessBanner: parseInt(this.flags)
        };
        this.$axios.post(this.Global.synchTradeSetting, params).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true, true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 查看拒绝原因
      viewRejectReason() {
        this.$axios.post(this.Global.viewRejectReason(this.shopMsg.Id), null).then((res) => {
          this.refusedReason = res.data.resData.RejectReason;
        });
      },

      // 获取店铺对接的关键字段
      getShopDockingKeyword() {
        this.$axios.get(this.Global.getShopDockingKeyword(this.shopMsg.Id)).then((res) => {
          this.appKeyTxt = res.data.resData.AppKey;
          this.appSecret = res.data.resData.AppSecret;
          this.sessionKey = res.data.resData.Sessionkey;
        });
      },

      // 保存店铺信息
      saveAddOrUpdateShopInfo() {
        if (!this.shopName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺名称';
        } else if (!this.shopNickName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺昵称';
        } else if (this.selectSource === '所有来源') {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择店铺来源';
        } else {
          let params;
          if (this.showType === 'addShop') {
            params = { // 新增店铺
              ShopName: this.shopName,
              ShopNick: this.shopNickName,
             /* AppSecret: this.appSecret,
              AppKey: this.appKey,
              SessionKey: this.sessionKey, */
              PlatformId: this.selectSource
            }
          } else {
            params = { // 编辑店铺
              Id: this.shopMsg.Id,
              ShopName: this.shopName,
              ShopNick: this.shopNickName,
             /* AppSecret: this.appSecret,
              AppKey: this.appKey,
              SessionKey: this.sessionKey, */
              PlatformId: this.selectSource
            }
          }
          this.$axios.post(this.Global.saveAddOrUpdateShopInfo, params).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true, true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        }
      },

      // 新增
      addShop() {
        if (this.selectSource === '所有来源') {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺来源';
        } else if (!this.shopName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺名称';
        } else if (!this.shopNickName) {
          this.isMsg = true;
          this.isSuc = false;
          if (this.selectSource === '3') {
            this.txtMsg = '请输入商家ID';
          } else {
            this.txtMsg = '请输入店铺昵称';
          }
        } else if (this.selectSource === '3' && !this.outShopId) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺ID';
        } else {
          if (this.selectSource !== '3') {
            this.outShopId = '';
          }
          const params = {
            ShopName: this.shopName,
            ShopNick: this.shopNickName,
            outShopId: this.outShopId,
           /* AppSecret: this.appSecret,
            AppKey: this.appKey,
            SessionKey: this.sessionKey, */
            PlatformId: this.selectSource
          };
          this.$axios.post(this.Global.saveAddOrUpdateShopInfo, params).then((res) => {
            this.handleRequset(res.data);
          });
        }
      },

      // 编辑店铺 PlatformId
      ModifyShop() {
        if (!this.shopName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺名称';
        } else if (this.shopMsg.PlatformId === 3 && !this.outShopId) {

        } else if (!this.shopNickName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入店铺昵称';
        } else {
          if (this.selectSource !== 3) {
            this.outShopId = '';
          }
          const params = {
            Id: this.shopMsg.Id,
            ShopName: this.shopName,
            ShopNick: this.shopNickName,
            outShopId: this.outShopId,
           /* AppSecret: this.appSecret,
            AppKey: this.appKey,
            SessionKey: this.sessionKey, */
            PlatformId: this.shopMsg.PlatformId
          };
          this.$axios.post(this.Global.saveAddOrUpdateShopInfo, params).then((res) => {
            this.handleRequset(res.data);
          });
        }
      },

      // 修改店铺的使用状态
      changeShopLocakStatusById() {
        let status;
        if (this.showType === 'enableShop') {
          status = 1;
        } else {
          status = 2;
        }
        this.$axios.post(this.Global.changeShopLocakStatusById(this.shopMsg.Id, status), null).then((res) => {
          this.handleRequset(res.data);
        });
      },

      // 根据id删除店铺信息
      delShopInfoById() {
        this.$axios.post(this.Global.delShopInfoById(this.shopMsg.Id), null).then((res) => {
          this.handleRequset(res.data);
        });
      },

      // 获取全部渠道信息 店铺对接渠道信息
      loadAllShopBindStoreroomAndStoreroomData() {
        this.$axios.post(this.Global.loadAllShopBindStoreroomAndStoreroomData(this.shopMsg.Id), null).then((res) => {
          if (!res.data.errorMsg.length) {
            let flag = true;
            this.checkboxModel = [];
            this.startCostLimit = res.data.resData.IsLimitStockCost;
            this.startRationLimit = res.data.resData.IsLimitSendRate;
            this.costLimit = res.data.resData.LimitStockCost;
            this.rationLimitVal = res.data.resData.LimitSendRate;
            this.channelList = res.data.resData.storeroomInfo;
            for (let i = 0; i < this.channelList.length; i++) {
             /* if (this.channelList[i].LimitCost) {
                this.checkboxModel.push(true);
              } else if (this.channelList[i].LimitCost === 0) {
                this.checkboxModel.push(true);
              } else {
                this.checkboxModel.push(false);
                flag = false;
              } */
              if (this.channelList[i].IsCheck) {
                this.checkboxModel.push(true);
              } else {
                this.checkboxModel.push(false);
                flag = false;
              }
            }
            if (!flag) {
              this.checkAll = false;
            }
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 配置对接渠道
      configureShopChannels() {
        let flag = true;
        let shopstoreInfo = []; // 选择的渠道数组
        if (this.startCostLimit && !this.costLimit) {
          flag = false;
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入成本限制过滤值';
        } else if (this.startRationLimit && !this.rationLimitVal) {
          flag = false;
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入配货率限制值';
        } else {
          for (let i = 0; i < this.checkboxModel.length; i++) {
            if (this.checkboxModel[i]) {
              // flag = true;
              // return flag;
             /* if (!this.channelList[i].LimitCost) {
                flag = false;
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请输入同步渠道的成本限制值';
              } else {
                shopstoreInfo.push({
                  SupplierCode: this.channelList[i].SupplierCode,
                  storeroomId: this.channelList[i].StoreroomId,
                  setOrderNum: this.channelList[i].SetOrderNum,
                  iimitCost: this.channelList[i].LimitCost
                });
              } */

              shopstoreInfo.push({
                SupplierCode: this.channelList[i].SupplierCode,
                storeroomId: this.channelList[i].StoreroomId,
                setOrderNum: this.channelList[i].SetOrderNum,
                iimitCost: this.channelList[i].LimitCost,
                SyncStockRate: this.channelList[i].SyncStockRate
              });
            }
          }
        }

        if (flag) {
          this.$axios.post(this.Global.saveShopBindStoreroomInfo(this.shopMsg.Id, this.costLimit, this.rationLimitVal, this.startCostLimit, this.startRationLimit), shopstoreInfo).then((res) => {
            this.handleRequset(res.data);
          });
        }
      },

      // 大于0小于100的浮点型数，维持两位数小数点
      rationLimitValFormat() {
        const reg = /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/;
        if (!reg.test(this.rationLimitVal)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入大于0小于100的数字(可保留小数点后两位数)';
          this.rationLimitVal = '';
        }
      },

      // 订单配仓优先级
      judgeNum(index) {
        if (this.channelList[index].SetOrderNum) {
          this.channelList[index].SetOrderNum = this.channelList[index].SetOrderNum.replace(/[^.\d]/g, '');
          if (this.channelList[index].SetOrderNum.indexOf('.') !== -1 || this.channelList[index].SetOrderNum < 0) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入大于0的正整数';
            this.channelList[index].SetOrderNum = '';
          }
          // 只能输入正整数的判断
         /* this.channelList[index].SetOrderNum = this.channelList[index].SetOrderNum.replace(/[^.\d]/g, '');
          this.channelList[index].SetOrderNum = this.channelList[index].SetOrderNum.replace('.', ''); */
        }
      },

      // 大于0小于1的浮点型数，维持两位数小数点
      limitCostFormat(index, type) {
        if (index === -1) { //
          this.costLimit = this.costLimit.replace(/[^.\d]/g, '');
        } else {
          // this.channelList[index].LimitCost = this.channelList[index].LimitCost.replace(/[^.\d]/g, '');
          this.channelList[index][type] = this.channelList[index][type].replace(/[^.\d]/g, '');
        }
        if (this.channelList[index][type]) {
          if (this.channelList[index][type].length > 4) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入大于0小于1的数字(可保留小数点后两位数)';
            if (index === -1) { // 判断成本限制率
              this.costLimit = '';
            } else { // 判断渠道库存成本限制
              // this.channelList[index].LimitCost = '';
              this.channelList[index][type] = '';
            }
          } else if (this.channelList[index][type] < 0 || this.channelList[index][type] > 1) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入大于0小于1的数字(可保留小数点后两位数)';
            if (index === -1) { // 判断成本限制率
              this.costLimit = '';
            } else { // 判断渠道库存成本限制
              // this.channelList[index].LimitCost = '';
              this.channelList[index][type] = '';
            }
          }
        }
        /* if (this.channelList[index].LimitCost) {
           if (this.channelList[index].LimitCost.length > 4) {
             this.isMsg = true;
          this.isSuc = false;
             this.txtMsg = '请输入大于0小于1的数字(可保留小数点后两位数)';
             this.channelList[index].LimitCost = '';
           } else if (this.channelList[index].LimitCost < 0 || this.channelList[index].LimitCost > 1) {
             this.isMsg = true;
          this.isSuc = false;
             this.txtMsg = '请输入大于0小于1的数字(可保留小数点后两位数)';
             this.channelList[index].LimitCost = '';
           }
         } */
        /* const reg = /^([0-1]\.\d{1,2})$/;
         if (!reg.test(this.channelList[index].LimitCost)) {
           this.isMsg = true;
          this.isSuc = false;
           this.txtMsg = '请输入大于0小于1的数字(可保留小数点后两位数)';
           this.channelList[index].LimitCost = '';
         } */
      },

      // 请求成功失败后处理
      handleRequset(data) {
        if (!data.errorMsg.length) {
          this.cancelBtn(true, true);
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = data.errorMsg;
        }
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'addShop') { // 新增店铺信息
          this.addShop();
        } else if (this.showType === 'modifyShop') { // 编辑
          this.ModifyShop();
        } else if (this.showType === 'enableShop' || this.showType === 'disableShop') { // 修改店铺的使用状态
          this.changeShopLocakStatusById();
        } else if (this.showType === 'delShop') {
          this.delShopInfoById();
        } else if (this.showType === 'configureChannels') { // 配置对接渠道
          this.configureShopChannels();
        } else if (this.showType === 'synchronousInventory') { // 同步整店库存
          this.updateOneShopGoodsStock();
        } else if (this.showType === 'orderSetting') { // 订单设置
          this.synchTradeSetting();
        } else {
          this.cancelBtn(true, true);
        }

        // 计时器
        this.time = 3;
        const self = this;
        this.timer = setInterval(function () {
          self.time = --self.time;
          if (self.time < 1) {
            self.isMsg = false;
            clearInterval(self.timer);
          }
        }, 1000);
      },

      // 取消按钮
      cancelBtn(type, issure) {
        this.$emit('cancelbtn', {isShow: false, issure: issure, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.shopStatus === 'synchronousInventoryDisable') { // 同步库存直接打开消息提示框后，关闭直接跳回原页面
          this.cancelBtn(true, true);
        }
      }
    },
    created() {
     /* if (this.shopMsg) {
        this.shopName = this.shopMsg.ShopName;
        this.shopNickName = this.shopMsg.ShopNick;
        this.appSecret = this.shopMsg.AppSecret;
        this.appKey = this.shopMsg.AppKey;
        this.sessionKey = this.shopMsg.SessionKey;
        this.selectSource = this.shopMsg.PlatformId;
      } */
      if (this.showType === 'addShop') {
        this.getAllPXOpenPlatformList();
      } else if (this.showType === 'modifyShop') {
        this.getShopModelById();
        this.outShopId = this.shopMsg.OutShopId;
        this.selectSource = this.shopMsg.PlatformId;
      } else if (this.showType === 'appSecret') {
        this.getShopDockingKeyword();
      } else if (this.showType === 'checkTheKey') {
        this.getShopDockingKeyword();
      } else if (this.showType === 'sessionKey') {
        this.getShopDockingKeyword();
      } else if (this.showType === 'configureChannels') {
        this.loadAllShopBindStoreroomAndStoreroomData();
      } else if (this.showType === 'synchronousInventory') {
       /* if (this.shopMsg.LockStatus === 2) { // 当店铺停用的时候，店铺不能同步库存
          this.shopStatus = 'synchronousInventoryDisable';
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '已停用店铺无法进行库存同步';
        } */
       // this.updateOneShopGoodsStock();
      } else if (this.showType === 'orderSetting') {
        this.getSynchTradeSetting();
      } else if (this.showType === 'refusedReason') {
        this.viewRejectReason();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .setup_shop_embed_msg {
    .select_dialog_embed_box {
      &.select_dialog_embed_box_w760 {
        width: 760px;

        .select_dialog_embed_box_handle {
          margin-top: 5px;
          font-size: 13px;
          width: 94%;

          & > div {
            margin: 0;

            &.remark {
              width: 97%;
              margin: 5px auto;

              p, textarea {
                width: 100%;
              }

              textarea {
                padding: 5px;
                height: 60px;
              }
            }

            label {
              width: initial!important;
            }
          }
        }
      }
      &.select_dialog_embed_box_w930 {
        width: 930px;

        .select_dialog_embed_box_handle {
          width: 98%;
          margin: auto;

          & > div {
            &:nth-child(1), &:nth-child(3) {
              input[type="checkbox"] {
                width: 18px;
              }

              label {
                width: 70%;
                text-align: left;
              }
            }

            &:nth-child(2), &:nth-child(4) {
              input[type='text'] {
                width: 13% !important;
                margin-right: 10px;
              }

              label {
                width: 16%;
                text-align: left;
                margin-right: 0;
              }
            }

            &:nth-child(2) {
              label {
                width: 11%;
              }
            }

            &:nth-child(5) {
              height: 370px;
              overflow-y: auto;

              .table {
                td {
                  input[type='text'] {
                    width: 130px;
                  }

                  input[type='checkbox'] {
                    width: 13px;
                    height: 13px;
                  }
                }
              }
            }
          }
        }
      }

      .select_dialog_embed_box_content {
        .select_dialog_embed_box_handle {
          & > div {

            label {
              width: 80px;

              i {
                color: $cred;
                margin-right: 2px;
              }
            }

            input[type='text'] {
              width: 68%;
            }

            &:nth-child(1), &:nth-child(2) {
              input[type='text'] {
                /*width: 50%;*/
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/setup-shop-embed-msg.vue